import { render, staticRenderFns } from "./MyProcedures.vue?vue&type=template&id=29482694&scoped=true&lang=pug"
import script from "./MyProcedures.vue?vue&type=script&lang=js"
export * from "./MyProcedures.vue?vue&type=script&lang=js"
import style0 from "./MyProcedures.vue?vue&type=style&index=0&id=29482694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29482694",
  null
  
)

export default component.exports